export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <div className="flex items-center gap-3" aria-label="C&R Mortgage Group">
      <div className="flex size-10 shrink-0 items-center justify-center bg-brand text-base font-black tracking-[-0.08em] text-ink">
        C<span className="mx-px text-[10px]">&</span>R
      </div>
      {compact ? null : (
        <div className="leading-none">
          <div className="text-[15px] font-extrabold tracking-tight">C&amp;R Mortgage</div>
          <div className="mt-1 text-[10px] font-bold uppercase tracking-[0.2em] text-neutral-500">
            Operations
          </div>
        </div>
      )}
    </div>
  );
}
